// Vue Core
import { createApp } from 'vue'
import App from '@/App.vue'

// Plugins
import vuetify from './plugins/vuetify'
import { registerPlugins } from '@core/utils/plugins'

// Charts - ECharts/VChart
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart } from 'echarts/charts'
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from 'echarts/components'

// External Libraries
import 'leaflet/dist/leaflet.css'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'
import './assets/main.css'

// Configure ECharts
use([
  CanvasRenderer,
  BarChart,
  LineChart,
  TooltipComponent,
  GridComponent,
  LegendComponent,
])

// Create and configure Vue app
const app = createApp(App)

// Register global components
app.component('VChart', VChart)

// Register plugins
app.use(vuetify)
registerPlugins(app)

// Mount application
app.mount('#app')
